import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { APIService } from './APIService/api.service';
import JSZip from 'jszip';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  private http = inject(HttpClient);
  private apiService = inject(APIService);

  API_URL: string;
  jwt: string;
  async upload(file: File): Promise<Observable<number>> {
    const formData = new FormData();

    let ext = file.name.split('.').pop();

    if (ext.toLowerCase() != 'zip') {
      var zip = new JSZip();
      let data = file.arrayBuffer();
      zip.file(file.name, data);
      const zipContent = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 9 },
      });

      formData.append('file', zipContent, file.name + '.zip');
    } else {
      formData.append('file', file, file.name);
    }

    //formData.append('file', file);
    this.API_URL = this.apiService.getURL();
    this.jwt = localStorage.getItem('jwt');

    let headers: any = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
        'ngsw-bypass': '',
        'Access-Control-Allow-Origin': '*',
      }),
      responseType: 'json',
      reportProgress: true,
    };

    let timeoutTime = 5 * 60 * 1000;
    let req = new HttpRequest('POST', this.API_URL + '/files/uploadfiles', formData, headers);

    return this.http.request(req).pipe(
      timeout(timeoutTime), // Timeout of 5 minutes
      catchError(error => {
        console.error(`Request timed out.`, error);
        return of(null); // Return null to continue with the next request
      }),
      map((event: HttpEvent<any>) => {
        try {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              return Math.round((100 * event.loaded) / (event.total || 1));

            case HttpEventType.Response:
              req = undefined;
              return 200;
            default:
              return 0;
          }
        } catch (e) {
          console.log(e);
          return 200;
        }
      })
    );

    /*
      return this.http.request(req).pipe(
        map((event: HttpEvent<any>) => {
          //console.log('event',event);
          try {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                return Math.round((100 * event.loaded) / (event.total || 1));

              case HttpEventType.Response:
                req = undefined;
                return 100;
              default:
                return 0;
            }
          } catch(e) {
            console.log(e);
            return 100;
          }
        })
      );
      */
  }
}
